import { render, staticRenderFns } from "./appeal-dialog.vue?vue&type=template&id=37d137c6&scoped=true"
import script from "./appeal-dialog.vue?vue&type=script&lang=js"
export * from "./appeal-dialog.vue?vue&type=script&lang=js"
import style0 from "./appeal-dialog.vue?vue&type=style&index=0&id=37d137c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d137c6",
  null
  
)

export default component.exports